import React from "react";
import PropTypes from 'prop-types';
import { TwitterTweetEmbed } from 'react-twitter-embed';

export default function TwitterBlock(
    {
        url
    }) {

    const tweetId = url?.match(/(?:\/status\/)([0-9]+)/);

    if (tweetId && tweetId[1]) {
        return (
            <div className="my-5 w-full content-center">
                <div className="mx-auto md:pl-28">
                    <TwitterTweetEmbed
                        tweetId={tweetId[1]}
                    />
                </div>
                
            </div>
        )
    }
    return (null)
}

TwitterBlock.propTypes = {
    url: PropTypes.string.isRequired
}